import { request } from "../libs";

function addZegebaContact(contact) {
	return request(
		"/server/contacts",
		{
			method: "POST",
			body: contact
		}
	)
		.then(res => res.statusCode);
}

export default addZegebaContact;



// WEBPACK FOOTER //
// ./src/api/add-zegeba-contact.js